import subjectsList from "./subjectsList"
import counsellingList from "./counsellingList"
import standartizedTests from "./standardizedTestList"

const subjectsAdvisingList = [...subjectsList, ...counsellingList, ...standartizedTests]

export default subjectsAdvisingList
